import { FormValidations } from "features/shared/forms/hooks/useForm";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";

const invalidIntegerValidation = {
  required: false,
  type: "Pattern",
  regex: /^\d+$/,
  message: "invalidInteger",
} as PatternValidatonRule;

export const newSimulationFormValidations = (): FormValidations => {
    return {
        STAV: invalidIntegerValidation,
        STAV_VT: invalidIntegerValidation,
        STAV_NT: invalidIntegerValidation
    }
}